import type { AdminToolIconId } from "./adminToolIcons";

export interface AdminToolDefinition {
  href: string;
  label: string;
  description: string;
  icon: AdminToolIconId;
  /** How to treat `href` when highlighting the active item. Defaults to prefix match. */
  match?: "exact" | "prefix";
}

export const ADMIN_TOOLS: AdminToolDefinition[] = [
  {
    href: "/admin/design-system",
    label: "Design System",
    description: "UI tokens, primitives, and component gallery.",
    icon: "design-system",
  },
  {
    href: "/admin/system-catalog",
    label: "System Catalog",
    description: "Manage folders, tile sets, and catalog structure.",
    icon: "system-catalog",
  },
  {
    href: "/admin/overlays",
    label: "Overlays",
    description: "Manage overlay items, packs, and compose availability.",
    icon: "overlays",
  },
  {
    href: "/admin/tiles",
    label: "Tiles",
    description: "Upload and organize base tiles for composing.",
    icon: "tiles",
  },
  {
    href: "/admin/compose",
    label: "Compose",
    description: "Combine base tiles and overlays into new system tiles.",
    icon: "compose",
  },
  {
    href: "/admin/users",
    label: "Users",
    description: "View registered users and staff roles.",
    icon: "users",
  },
];
